// extracted by mini-css-extract-plugin
export default {"message":"StatusMessage--message--d97d7c","header":"StatusMessage--header--8b8c48","icon":"StatusMessage--icon--5c1988","description":"StatusMessage--description--a2e940"};